"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function createModify(getter, setter) {
  return function modify(updateFn, s) {
    return setter(updateFn(getter(s)), s);
  };
}

var Optic;

(function (Optic) {
  function optic(getter, setter) {
    return {
      get: getter,
      set: setter,
      modify: createModify(getter, setter)
    };
  }

  Optic.optic = optic;
})(Optic = exports.Optic || (exports.Optic = {}));

var Prism;

(function (Prism) {
  function create(getter, setter) {
    return {
      get: getter,
      set: setter,
      modify: createModify(getter, setter),
      compose: function compose(next) {
        // no runtime dispatch – the implementation works for both
        // lens and prism argument
        return create(function (s) {
          var x = getter(s);
          return x !== undefined ? next.get(x) : undefined;
        }, function (v, s) {
          var x = getter(s);
          return x !== undefined ? setter(next.set(v, x), s) : s;
        });
      }
    };
  }

  Prism.create = create;
})(Prism = exports.Prism || (exports.Prism = {}));

var Lens;

(function (Lens) {
  /**
   * Create a lens.
   *
   * @export
   * @template O type of the source
   * @template P type of the destination
   * @param getter a getter function
   * @param setter a setter function
   * @returns a lens that operates by given getter and setter
   */
  function create(getter, setter) {
    return {
      get: getter,
      set: setter,
      modify: createModify(getter, setter),
      compose: function compose(next) {
        return create(function (s) {
          return next.get(getter(s));
        }, function (v, s) {
          return setter(next.set(v, getter(s)), s);
        });
      }
    };
  }

  Lens.create = create;

  function compose() {
    var lenses = [];

    for (var _i = 0; _i < arguments.length; _i++) {
      lenses[_i] = arguments[_i];
    }

    if (lenses.length === 0) {
      throw new TypeError('Can not compose zero lenses. You probably want `Lens.identity`.');
    } else if (lenses.length === 1) {
      return lenses[0];
    } else {
      var r_1 = lenses[0];
      lenses.slice(1).forEach(function (l) {
        r_1 = r_1.compose(l);
      });
      return r_1;
    }
  }

  Lens.compose = compose;

  var _identity = create(function (x) {
    return x;
  }, function (x, _) {
    return x;
  });
  /**
   * The identity lens – a lens that reads and writes the object itself.
   */


  function identity() {
    return _identity;
  }

  Lens.identity = identity;

  var _nothing = Prism.create(function (_) {
    return undefined;
  }, function (_, o) {
    return o;
  });
  /**
   * A lens that always returns `undefined` on `get` and does no change on `set`.
   */


  function nothing() {
    return _nothing;
  }

  Lens.nothing = nothing;
})(Lens = exports.Lens || (exports.Lens = {}));